export const SET_ENVIRONMENT_VARS = 'Environment/SET_ENVIRONMENT_VARS';
